import { render, staticRenderFns } from "./WorkshopStatusCpt.vue?vue&type=template&id=e877ed0e&scoped=true&"
import script from "./WorkshopStatusCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopStatusCpt.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopStatusCpt.vue?vue&type=style&index=0&id=e877ed0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e877ed0e",
  null
  
)

export default component.exports